/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { addLocaleData } from 'react-intl';
import enLocaleData from 'react-intl/locale-data/en';
import deLocaleData from 'react-intl/locale-data/de';

import App from './App';
import { LocaleProvider } from './languages/LocaleProvider';
import AppIntlProvider from './helper/AppIntlProvider';
import IntlGlobalProvider from './helper/IntlGlobalProvider';
import './index.css';
import store from './store';
import { BrowserRouter } from 'react-router-dom';

addLocaleData([...deLocaleData, ...enLocaleData]);

ReactDOM.render(
	<Provider store={store}>
		<LocaleProvider>
			<AppIntlProvider>
				<IntlGlobalProvider>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</IntlGlobalProvider>
			</AppIntlProvider>
		</LocaleProvider>
	</Provider>,
	document.getElementById('root')
);
